import React, { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, deskMobx, restaurantConfig } from 'restaurant'
import { decorationMobx, deliveryMobx, storeMobx } from '@mobxStore'
import { showMsg, useHistoryNew, modalLayer, confirmLayer, getHistoryNew } from '@utils'
import { Icon, SelectAddressModal } from '@cps'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import { TCodeType } from 'restaurant/mobx/center/restaurantCenter'
import DeliveryController from '@ctrls/deliveryController'

import './index.scss'

// interface
interface IProps {
}
const StoreInfoBar: FC<IProps> = () => {
  const history = useHistoryNew()
  const isBuyTogether = !!Config.buyTogetherId
  const { eatTypeEntries, eatTypeEntriesMap } = decorationMobx
  const { address, viewAddresses } = deliveryMobx
  const { info: store } = storeMobx
  const eatType = cartMobx.info.eatType
  /** 外卖并且不是拼单 */
  const showDelivery = restaurantConfig.codeType === TCodeType.Brand && eatType === TEEatType.delivery && !isBuyTogether
  const goToStore = (eatType?: TEEatType) => {
    if (cartMobx.ordersId) {
      showMsg(i18n.t('menu.disableSwitchStore'))
      return
    }
    if (restaurantConfig.codeType === TCodeType.Brand && !isBuyTogether) {
      if (eatType === TEEatType.delivery) {
        history.push('/store', null, { isDelivery: '1' })
      } else {
        history.push('/store', null, { et: eatType })
      }
    }
  }
  const eatTypeEntriesValueArr = useMemo(() => {
    const arr: TEatType[] = eatTypeEntries.map(item => item.value)
    return arr
  }, [eatTypeEntries])
  const storeAddress = useMemo(() => {
    if (restaurantConfig.codeType === TCodeType.Table) {
      return deskMobx.tableCodeToTableAliasMap[Config.TABLECODE]
    }
    if (restaurantConfig.codeType === TCodeType.Store) {
      return store.address
    }
    return store.distance ? i18n.t('menu.distance', { distance: store.distanceWithUnit }) : store.address
  }, [storeMobx.info, deskMobx.tableCodeToTableAliasMap])
  /** 选择其他地址 */
  const handleSelectAddress = async () => {
    if (viewAddresses?.length) {
      modalLayer(SelectAddressModal, {
        eatType: TEEatType.delivery
      }, 'SelectAddressModal').then(() => {
      }, () => { })
    } else {
      DeliveryController.editAddressModal({
        eatType: TEEatType.delivery,
        callback (store) {
          if (store) {
            confirmLayer({
              title: i18n.t('common.attention'),
              children: (
                <>
                  <div className='near-tip'>{i18n.t('newCart.matchNearStore')}</div>
                  <div className='near-store'>
                    <Icon name='dinein3' />{store?.storeName}
                  </div>
                </>
              ),
              className: 'near-store-confirm-modal',
              isLight: true,
              canClose: true,
            }).then(() => {
              storeMobx.initInfo(store)
            }, () => {})
          }
        }
      })
    }
  }
  const StoreTags = () => {
    return (
      <div className='store-tag'>
        {
          eatTypeEntries.length < 2 || !eatTypeEntriesValueArr.includes(eatType) ? (
            <span className='store-eat-tag'>
              {eatTypeEntriesMap[eatType]?.name || i18n.t(`entry.${eatType}`)}
            </span>
          ) : null
        }
        {
          store.boughtCnt ? (
            <span className='store-bought-cnt'><span className='txt'>{i18n.t('store.boughtStoreByStore', { num: store.boughtCnt })}</span></span>
          ) : null
        }
      </div>
    )
  }
  /** 外卖展示的门店结构 */
  const StoreDelivery = () => {
    return (
      <div className='store-info-bar delivery'>
        <div className='store-name-wrapper' onClick={() => goToStore(TEEatType.delivery)}>
          <Icon name='mendian1' />
          <span className='store-name-txt'>{store.storeName}</span>
          {restaurantConfig.codeType === TCodeType.Brand && !isBuyTogether && <Icon name='chevron-right' />}
          <StoreTags />
          <div className='arrow-icon'>
            <Icon name='jiantou' />
          </div>
        </div>
        <div className='address-wrapper' onClick={handleSelectAddress}>
          <Icon name='mubiao' />
          <span className='address-name'>
            {
              address ? (
                `${address.address} ${address.addressDetail}`
              ) : deliveryMobx.availableAddress && restaurantConfig.lbsAddress ? (
                restaurantConfig.lbsAddress
              ) : (
                i18n.t(!viewAddresses?.length ? 'newCart.addAddressTip' : 'newCart.selectAddress')
              )
            }
          </span>
          <div className='change-icon' data-cypid='bt-cart-change-address'>
            <Icon name='change' />
          </div>
        </div>
      </div>
    )
  }
  /** 默认展示 */
  const StoreDefault = () => {
    return (
      <div className='store-info-bar default'>
        <div className='store-name' onClick={() => goToStore()}>
          <span className='store-name-txt'>{store.storeName}</span>
          {restaurantConfig.codeType === TCodeType.Brand && !isBuyTogether && <Icon name='chevron-right' />}
        </div>
        <div className='store-infos'>
          <div className='store-address'>{storeAddress}</div>
          <StoreTags />
        </div>
      </div>
    )
  }
  return (
    showDelivery ? (
      <StoreDelivery />
    ) : (
      <StoreDefault />
    )
  )
}

export default observer(StoreInfoBar)
